/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    loginBtn: {
      fontFamily: 'Roboto',
      paddingLeft: 8,
      paddingRight: 8,
      height: theme.spacing(6),
      minHeight: 38,
      width: 215,
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.5,
      borderRadius: theme.spacing(0.5),
      letterSpacing: 0.22,
      boxShadow: `0px 1px 1px ${theme.palette.grey[200]}`,
      border: `1px solid ${theme.palette.grey[100]}`,
      marginTop: theme.spacing(1.5),
      backgroundColor: theme.palette.common.white,
      whiteSpace: 'nowrap',
      '&:hover, &:focus, &:active': {
        backgroundColor: '#EEEEEE',
        boxShadow: '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)',
      },
    },
    btnIcon: {
      marginRight: theme.spacing(3),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
      marginLeft: theme.spacing(-4.5),
    },
    emailBtnIcon: {
      margin: theme.spacing(0, 2.875, -0.1, -7.3),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
    },
    enterpriseBtnIcon: {
      margin: theme.spacing(0, 3, 0, -1.5),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
    },
    microsoftBtnIcon: {
      marginLeft: theme.spacing(-2.5),
      marginRight: theme.spacing(2.875),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
    },
    github: {
      color: 'rgba(0,0,0,0.8)',
      width: theme.spacing(31),
    },
    google: {
      color: 'rgba(0,0,0,0.8)',
      width: theme.spacing(31),
    },
    microsoft: {
      color: 'rgba(0,0,0,0.8)',
      width: theme.spacing(31),
    },
    enterprise: {
      color: 'rgba(0,0,0,0.8)',
      width: theme.spacing(31),
    },
    enterpriseBannerTooltipTextContainer: {
      paddingTop: theme.spacing(1.5),
      paddingLeft: theme.spacing(0.875),
      paddingBottom: theme.spacing(0.375),
    },
    enterpriseBannerTooltipText: {
      paddingBottom: theme.spacing(1.75),
    },
    emailIcon: {
      fontSize: theme.spacing(2),
    },
  })
);
